module.exports = __webpack_public_path__ + "4ea8deefc665f996fc4349722f999ca8.pdf";